// extracted by mini-css-extract-plugin
module.exports = {"detailsSubTitleRow":"InstitutionDetailsModal_detailsSubTitleRow__Z7dbZ","subTitle":"InstitutionDetailsModal_subTitle__3JXBh","criterion":"InstitutionDetailsModal_criterion__64xNf"};